export function generic(type, params) {
  return {
    type,
    ...params,
  };
}
